module.exports = __webpack_public_path__ + "static/media/selectDropdownArrowIcon.09c13ab8.svg";